import { api } from '@/lib/axios'

export type FrontChatIdentityType = {
  userId: string
  userHash: string
}

async function getFrontChatIdentity() {
  const { data } = await api.get<FrontChatIdentityType>('/front-chat/identity')

  return data
}

export { getFrontChatIdentity }
